import { stringifyValue } from "@entrilia/shared/utilities/stringHelper";
import type {
  Field,
  LookupObjectReference,
  ObjectTypeToLookupReferences,
  RelatedObjectsResponse,
} from "../../../../api/types/objectTypes";
import { getLookupOptionDisplayValue, type DocumentCitation } from "../../../entityFields/helpers";

// The backend sends no options for a HiddenByDefault lookup together with the rows
export const getLazyLookupOptionsType = ({ attributes, configuration }: Field): string | undefined =>
  attributes.includes("HiddenByDefault") && configuration?.$type === "Lookup" ? configuration.objectType : undefined;

export type FieldValueLabeler = (fieldId: string, value: unknown) => string;

export const getFieldValueLabel = (
  fields: Field[],
  fieldId: string,
  value: unknown,
  lookupOptions: ObjectTypeToLookupReferences,
  lookupObjects: LookupObjectReference[]
): string => {
  const configuration = fields.find((field) => field.id === fieldId)?.configuration;
  if (configuration?.$type !== "Lookup" || typeof value !== "string") {
    return stringifyValue(value);
  }

  return (
    getLookupOptionDisplayValue(value, [...lookupObjects, ...(lookupOptions[configuration.objectType] ?? [])]) ?? ""
  );
};

export const getLookupOptionAdditionalFieldValue = (
  objectId: unknown,
  lookupReferences: LookupObjectReference[],
  additionalFieldId: string
): string | undefined =>
  lookupReferences
    .find((ref) => ref.objectId === objectId)
    ?.additionalFieldValues?.find((additionalField) => additionalField.fieldId === additionalFieldId)?.fieldValue;

export const getRelatedCitationKey = (rowId: string, fieldId: string): string => `${rowId}:${fieldId}`;

export const collectRelatedCitations = (relatedObjectsByType: RelatedObjectsResponse[]): DocumentCitation[] => {
  const citations: DocumentCitation[] = [];

  for (const group of relatedObjectsByType) {
    for (const relatedObject of group.relatedObjects) {
      for (const [fieldId, citation] of Object.entries(relatedObject.fieldsCitations ?? {})) {
        citations.push({ key: getRelatedCitationKey(relatedObject.id, fieldId), ...citation });
      }
    }
  }

  return citations;
};
